import React from 'react'
import { connect } from 'react-redux'
import { getFormValues, Field } from 'redux-form'
import { Popup, Label } from 'semantic-ui-react'
import { lower } from 'change-case'
import r from 'reactotron-react-js'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { numberFormat } from '../../helper'
import { withholdingTaxList } from '../../AttributeData'
import { purchaseOrderDetailPath } from 'routes'
import { mathRoundDigit } from 'core/utilities'

import {
  Cont,
  THeader,
  TBody,
  TFooter,
  THPage,
  ItemContainer
} from './styled'

const itemPerPage = 10

const PanelPOInfo = props => {
  const {
    isCreate = false,
    isEdit = false,
    valueForm,
    change = null,
    totalPages,
    totalPagesSelect,
  } = props

  const [drFocus, setdrFocus] = React.useState(false)
  const [daFocus, setdaFocus] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const [allPage, setAllPage] = React.useState(false)

  const calBillAmount = (value) => {
    return ((Number(value.totalInvoiceAmount || 0) +
      Number(Math.abs(value.deductDownPayment || 0) * (-1)) +
      Number(Math.abs(value.withholdingTax || 0) * (-1)) +
      Number(Math.abs(value.deductRetentionAmount || 0) * (-1))) +
      Number(value.otherValue1 || 0) +
      Number(value.otherValue2 || 0) +
      Number(value.otherValue3 || 0) +
      Number(value.vatAmount)).toFixed(2)
  }

  React.useEffect(() => {
    if ((valueForm.otherName1 && !(valueForm.otherName1.trim().length)) || valueForm.otherName1 === undefined) {
      change && change(`otherValue1`, '')
    }
    if ((valueForm.otherName2 && !(valueForm.otherName2.trim().length)) || valueForm.otherName2 === undefined) {
      change && change(`otherValue2`, '')
    }
    if ((valueForm.otherName3 && !(valueForm.otherName3.trim().length)) || valueForm.otherName3 === undefined) {
      change && change(`otherValue3`, '')
    }
  }, [(valueForm && valueForm.otherName1), (valueForm && valueForm.otherName2), (valueForm && valueForm.otherName3)])

  React.useEffect(() => {
    if (daFocus) {
      props.change('deductRetentionRate', null)
      let billingAmount = calBillAmount(valueForm)
      props.change('billingAmount', billingAmount)
    }
  }, [(valueForm && valueForm.deductRetentionAmount)])

  React.useEffect(() => {
    if (drFocus) {
      let amount = 0
      if (valueForm.deductRetentionRate) {
        amount = ((valueForm.deductRetentionRate * valueForm.totalInvoiceAmount) / 100).toFixed(2)
        props.change('deductRetentionAmount', amount)
      } else {
        props.change('deductRetentionAmount', null)
      }
      let billingAmount = calBillAmount({ ...valueForm, deductRetentionAmount: amount })
      props.change('billingAmount', billingAmount)
    }
  }, [(valueForm && valueForm.deductRetentionRate)])

  React.useEffect(() => {
    let withholdingTaxAmount = 0
    let vatAmount = 0
    if (valueForm.withholdingTaxRate) {
      if (valueForm.withholdingTaxRate != 'amount') {
        withholdingTaxAmount = mathRoundDigit((((Number(valueForm.totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.withholdingTaxRate) / 100),2)
        props.change('withholdingTax', withholdingTaxAmount)
      }
    }
    if(isEdit || isCreate){
      if (valueForm.vatRate) {
        vatAmount = (((Number(valueForm.totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.vatRate) / 100).toFixed(2)
        props.change('vatAmount', vatAmount)
      }
    }else{
      vatAmount = valueForm.vatAmount
    }
    let billingAmount = calBillAmount(
      {
        ...valueForm,
        withholdingTax: withholdingTaxAmount,
        vatAmount: vatAmount
      }
    )
    props.change('billingAmount', billingAmount)
  }, [(valueForm && valueForm.deductDownPayment)])

  React.useEffect(() => {
    if(isEdit || isCreate){
      let vatAmount = 0
      if (valueForm.vatRate) {
        vatAmount = (((Number(valueForm.totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.vatRate) / 100).toFixed(2)
      }
      props.change('vatAmount', vatAmount)
      let billingAmount = calBillAmount({ ...valueForm, vatAmount: vatAmount })
      props.change('billingAmount', billingAmount)
    }
  }, [(valueForm && valueForm.vatRate)])

  React.useEffect(() => {
    let withholdingTaxAmount = 0
    if (valueForm.withholdingTaxRate) {
      if (valueForm.withholdingTaxRate != 'amount') {
        withholdingTaxAmount = mathRoundDigit((((Number(valueForm.totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.withholdingTaxRate) / 100),2)
      }
    }
    r.log(withholdingTaxAmount)
    props.change('withholdingTax', withholdingTaxAmount)
  }, [(valueForm && valueForm.withholdingTaxRate)])

  React.useEffect(() => {
    let billingAmount = calBillAmount(valueForm)
    props.change('billingAmount', billingAmount)
  }, [(valueForm && valueForm.withholdingTax)])

  React.useEffect(() => {
    let billingAmount = calBillAmount(valueForm)
    props.change('billingAmount', billingAmount)
  }, [(valueForm && valueForm.otherValue1), (valueForm && valueForm.otherValue2), (valueForm && valueForm.otherValue3)])


  React.useEffect(() => {
    let totalNetAmount = 0
    let totalInvoiceAmount = 0
    let totalAdjustAmount = 0
    let withholdingTaxAmount = valueForm.withholdingTax || 0
    let vatAmount = 0
    let billingAmount = 0
    let deductRetention = valueForm.deductRetentionAmount || 0

    valueForm.goodsServiceReceiptPoItems.forEach((x, i) => {
      totalNetAmount = Number(totalNetAmount) + Number(x.totalNetAmount)
      totalInvoiceAmount = Number(totalInvoiceAmount) + Number(x.totalInvoiceAmount)
      totalAdjustAmount = Number(totalAdjustAmount) + Number(x.adjustAmount || 0)
    })

    if (valueForm.withholdingTaxRate) {
      if (valueForm.withholdingTaxRate != 'amount') {
        withholdingTaxAmount = mathRoundDigit((((Number(totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.withholdingTaxRate) / 100),2)
      }
    }

    if (valueForm.deductRetentionRate) {
      deductRetention = ((valueForm.deductRetentionRate * totalInvoiceAmount) / 100).toFixed(2)
    }

    if(isEdit || isCreate){
      if (valueForm.vatRate) {
        vatAmount = (((Number(totalInvoiceAmount) - Number(Math.abs(valueForm.deductDownPayment || 0))) * valueForm.vatRate) / 100).toFixed(2)
      }
    }else{
      vatAmount = valueForm.vatAmount
    }

    billingAmount = calBillAmount(
      {
        ...valueForm,
        totalInvoiceAmount: totalInvoiceAmount,
        withholdingTax: withholdingTaxAmount,
        deductRetentionAmount: deductRetention,
        vatAmount: vatAmount
      })

    props.change('totalNetAmount', totalNetAmount)
    props.change('totalInvoiceAmount', totalInvoiceAmount)
    props.change('totalAdjustAmount', totalAdjustAmount)
    props.change('deductRetentionAmount', deductRetention)
    props.change('withholdingTax', withholdingTaxAmount)
    props.change('vatAmount', vatAmount)
    props.change('billingAmount', billingAmount)
  }, [(valueForm && valueForm.goodsServiceReceiptPoItems)])

  const calculatePOItemQuantity = (value, index) => {
    let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPoItems))
    let item = clone[index]
    item.qtyReceive = item.qtyRemain < value ? item.qtyRemain : value
    if (!item.qtyReceive || item.qtyReceive == 0) {
      item.adjustAmount = 0
    }
    item.totalNetAmount = (item.netPrice * item.qtyReceive).toFixed(2)
    item.totalInvoiceAmount = Number(item.totalNetAmount + (item.adjustAmount || 0)).toFixed(2)
    change && change(`goodsServiceReceiptPoItems[${index}]`, item)
  }

  const calculatePOItemAdjustAmount = (value, index) => {
    let clone = JSON.parse(JSON.stringify(valueForm.goodsServiceReceiptPoItems))
    let item = clone[index]
    item.adjustAmount = value || 0
    item.totalInvoiceAmount = Number(item.totalNetAmount) + Number(item.adjustAmount)
    change && change(`goodsServiceReceiptPoItems[${index}]`, item)
  }

  const openPODetail = (poItem) => {
    let po = valueForm.goodsServiceReceiptPOs.find(xx => xx.purchaseOrderSapNumber == poItem.purchaseOrderSapNumber)
    window.open(purchaseOrderDetailPath(po.purchaseOrderId || po.id))
  }

  const onPageChange = (page) => {
    setPage(page)
    setAllPage(false)
  }

  const onAllPageClick = () => {
    setAllPage(!allPage)
  }

  const clearWithholdingTax = () => {
    if (isCreate) {
      props.change('withholdingTaxRate', '')
      props.change('withholdingTax', '')
    }
  }

  return (
    <ItemContainer>
      <Cont>
        <THeader>
          <div style={{ maxWidth: '5%', flex: 1, minWidth: '4%' }}>No</div>
          <div style={{ maxWidth: '21%', flex: 1, minWidth: '8%' }}>PO No.</div>
          <div style={{ maxWidth: '21%', flex: 1, minWidth: '4%' }}>Item<br />No.</div>
          <div style={{ maxWidth: '21%', flex: 1, minWidth: '8%' }}>Material No.</div>
          <div style={{ maxWidth: '21%', flex: 1, minWidth: '9%' }}>Item Name</div>
          {((isCreate || isEdit) || (valueForm.status == 5)) && <div style={{ maxWidth: '7%', flex: 1, minWidth: '7%' }}>Remaining<br />Qty</div>}
          <div style={{ maxWidth: '7%', flex: 1, minWidth: '7%' }}>Quantity</div>
          <div style={{ maxWidth: '6%', flex: 1, minWidth: '4%' }}>Unit</div>
          <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }}>Net Price</div>
          <div style={{ maxWidth: '6%', flex: 1, minWidth: '6%' }}>Currency</div>
          <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }}>Total Net Amount</div>
          <div style={{ maxWidth: '12%', flex: 1, minWidth: '10%' }}>Adjust Amount</div>
          <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }}>Total Invoice Amount</div>
        </THeader>
        {valueForm && valueForm.goodsServiceReceiptPoItems && valueForm.goodsServiceReceiptPoItems.map((x, i) => {
          let pp = Math.ceil((i + 1) / itemPerPage)
          if ((pp <= page && pp > (page - 1)) || allPage) {
            let active = valueForm.goodsServiceReceiptPoItems[i].qtyReceive
            return (
              <TBody key={`tb${i}`} className={(active && (isCreate || isEdit)) ? 'itemActive' : ''}>
                <div style={{ maxWidth: '5%', flex: 1, minWidth: '4%' }}>{(i + 1)}</div>
                <div className='colPRRef' style={{ maxWidth: '21%', flex: 1, minWidth: '8%' }} onClick={() => openPODetail(x)}>{x.purchaseOrderSapNumber}</div>
                <div style={{ maxWidth: '21%', flex: 1, minWidth: '4%' }}>{x.lineNo}</div>
                <div style={{ maxWidth: '21%', flex: 1, minWidth: '8%' }} className='left'>
                  <Popup
                    trigger={<div className='itemName'>{Number(`${x.materialNo}`) || ''}</div>}
                    content={Number(`${x.materialNo}`) || ''}
                    basic
                  />
                </div>
                <div style={{ maxWidth: '21%', flex: 1, minWidth: '9%' }} className='left'>
                  <Popup
                    trigger={<div className='itemName'>{x.itemName}</div>}
                    content={x.itemName}
                    basic
                  />
                </div>
                {((isCreate || isEdit) || (valueForm.status == 5)) && <div style={{ maxWidth: '7%', flex: 1, minWidth: '7%' }} className='right'>{numberFormat(x.qtyRemain, false, 3)}</div>}
                <div style={{ maxWidth: '7%', flex: 1, minWidth: '7%' }} className='right fieldData'>
                  <Field
                    name={`goodsServiceReceiptPoItems[${i}].qtyReceive`}
                    type={type.number}
                    decimalScale={3}
                    fixedDecimalScale={true}
                    specialOnChange={(v) => {
                      calculatePOItemQuantity(v, i)
                    }}
                    component={FieldInput}
                    editable={(isCreate || isEdit) ? true : false}
                  />
                </div>
                <div style={{ maxWidth: '6%', flex: 1, minWidth: '4%' }}>{x.unitName}</div>
                <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }} className='right'>{numberFormat(x.netPrice) || numberFormat((x.grossPrice / x.unitPrice).toFixed(2))}</div>
                <div style={{ maxWidth: '6%', flex: 1, minWidth: '6%' }}>{(isCreate || isEdit) ? x.currency : x.currencyCode}</div>
                <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }} className='right'>{numberFormat(x.totalNetAmount)}</div>
                <div style={{ maxWidth: '12%', flex: 1, minWidth: '10%' }} className='right fieldData'>
                  <Field
                    name={`goodsServiceReceiptPoItems[${i}].adjustAmount`}
                    type={type.number}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    specialOnChange={(v) => {
                      calculatePOItemAdjustAmount(v, i)
                    }}
                    component={FieldInput}
                    className={`${x.adjustAmount < 0 ? 'minusData' : ''}`}
                    // editable={(isCreate||isEdit)?true:false}
                    editable={(isCreate || isEdit) ? (valueForm.goodsServiceReceiptPoItems[i].qtyReceive > 0) || false : false}
                  />
                </div>
                <div style={{ maxWidth: '12%', flex: 1, minWidth: '11%' }} className='right'>{numberFormat(x.totalInvoiceAmount)}</div>
              </TBody>
            )
          } else return null
        })}
        {totalPages > 1 && <THPage>
          <React.Fragment>
            {`Page `}
            <select
              onChange={e => onPageChange(Number(e.target.value))}
              value={page}
            >
              {totalPagesSelect.map((option, i) => (
                <option key={i} value={option}>{option}</option>
              ))}
            </select>
            {` /${totalPages} `}
            <Label as='a' onClick={() => onAllPageClick()}>All</Label>
          </React.Fragment>
        </THPage>}
        <TFooter>
          <div className='row'>
            <div className='title'>Total Net Amount</div>
            <div className='data'>{numberFormat(valueForm.totalNetAmount)}</div>
          </div>
          <div className='row'>
            <div className='title'>Total invoice Amount</div>
            <div className='data'>{numberFormat(valueForm.totalInvoiceAmount)}</div>
          </div>
          <div className='row'>
            <div className='title'>Total Adjust Amount</div>
            <div className={`data ${valueForm.totalAdjustAmount < 0 ? 'minusData' : ''}`}>{numberFormat(valueForm.totalAdjustAmount, true)}</div>
          </div>
          <div className='row'>
            <div className='title'>Deduct Down Payment / Advance Payment</div>
            <div className='data fieldData'>
              <Field
                className={`dataField ${(isCreate || isEdit) ? 'minusData' : (valueForm && valueForm.deductDownPayment) ? 'minusData' : ''}`}
                name={'deductDownPayment'}
                type={type.number}
                prefix={(isCreate || isEdit) ? '-' : (valueForm && valueForm.deductDownPayment) ? '-' : ''}
                decimalScale={2}
                allowNegative={false}
                fixedDecimalScale={true}
                component={FieldInput}
                alwayNegative
                editable={(isCreate || isEdit) ? true : false}
              />
            </div>
          </div>
          {lower(valueForm.mainDeliveryType) !== 'service' ? clearWithholdingTax() :
            // {lower(valueForm.mainDeliveryType)!=='service'?null:
            <div className='row'>
              <div className='title fieldData'>
                Withholding tax
            <Field
                  name={'withholdingTaxRate'}
                  type={type.select}
                  allowAdditions={false}
                  options={withholdingTaxList}
                  component={FieldInput}
                  editable={(isCreate || isEdit) ? true : false}
                />
              </div>
              <div className='data fieldData'>
                <Field
                  className={`dataField ${(isCreate || isEdit) ? 'minusData' : (valueForm && valueForm.withholdingTax) ? 'minusData' : ''}`}
                  name='withholdingTax'
                  type={type.number}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  component={FieldInput}
                  allowNegative={false}
                  prefix={(isCreate || isEdit) ? '-' : (valueForm && valueForm.withholdingTax) ? '-' : ''}
                  editable={(isCreate || isEdit) ? (valueForm.withholdingTaxRate && lower(valueForm.withholdingTaxRate) === 'amount') || false : false}
                />
              </div>
            </div>}
          <div className='row'>
            <div className='title fieldData'>
              Deduct Retention / Warranty
            <Field
                name={'deductRetentionRate'}
                type={type.number}
                component={FieldInput}
                suffix='%'
                editable={(isCreate || isEdit) ? true : false}
                specialOnFocus={() => {
                  setdrFocus(true)
                  setdaFocus(false)
                }}
              />
            </div>
            <div className='data fieldData'>
              <Field
                className={`dataField ${(isCreate || isEdit) ? 'minusData' : (valueForm && valueForm.deductRetentionAmount) ? 'minusData' : ''}`}
                name={'deductRetentionAmount'}
                type={type.number}
                decimalScale={2}
                prefix={(isCreate || isEdit) ? '-' : (valueForm && valueForm.deductRetentionAmount) ? '-' : ''}
                allowNegative={false}
                fixedDecimalScale={true}
                component={FieldInput}
                alwayNegative
                editable={(isCreate || isEdit) ? true : false}
                specialOnFocus={() => {
                  setdaFocus(true)
                  setdrFocus(false)
                }}
              />
            </div>
          </div>
          <div className='row'>
            <div className='title fieldData'>
              Other 1
            <Field
                name={'otherName1'}
                type={type.text}
                component={FieldInput}
                editable={(isCreate || isEdit) ? true : false}
              />
            </div>
            <div className='data fieldData'>
              <Field
                className={`dataField ${valueForm.otherValue1 < 0 ? 'minusData' : ''}`}
                name={'otherValue1'}
                type={type.number}
                decimalScale={2}
                fixedDecimalScale={true}
                component={FieldInput}
                editable={(isCreate || isEdit) ? (valueForm.otherName1 && valueForm.otherName1.trim().length) || false : false}
              />
            </div>
          </div>
          <div className='row'>
            <div className='title fieldData'>
              Other 2
            <Field
                name={'otherName2'}
                type={type.text}
                component={FieldInput}
                editable={(isCreate || isEdit) ? true : false}
              />
            </div>
            <div className='data fieldData'>
              <Field
                className={`dataField ${valueForm.otherValue2 < 0 ? 'minusData' : ''}`}
                name={'otherValue2'}
                type={type.number}
                decimalScale={2}
                fixedDecimalScale={true}
                component={FieldInput}
                editable={(isCreate || isEdit) ? (valueForm.otherName2 && valueForm.otherName2.trim().length) || false : false}
              />
            </div>
          </div>
          <div className='row'>
            <div className='title fieldData'>
              Other 3
            <Field
                name={'otherName3'}
                type={type.text}
                component={FieldInput}
                editable={(isCreate || isEdit) ? true : false}
              />
            </div>
            <div className='data fieldData'>
              <Field
                className={`dataField ${valueForm.otherValue3 < 0 ? 'minusData' : ''}`}
                name={'otherValue3'}
                type={type.number}
                decimalScale={2}
                fixedDecimalScale={true}
                component={FieldInput}
                editable={(isCreate || isEdit) ? (valueForm.otherName3 && valueForm.otherName3.trim().length) || false : false}
              />
            </div>
          </div>
          <div className='row'>
            <div className='title fieldData'>
              Vat
            <Field
                name={'vatRate'}
                type={type.number}
                suffix='%'
                component={FieldInput}
                editable={(isCreate || isEdit) ? true : false}
              />
            </div>
            <div className='data'>{numberFormat(valueForm.vatAmount)}</div>
          </div>
          <div className='row'>
            <div className='title'>Net Amount after deduction</div>
            <div className='data'>{numberFormat(valueForm.billingAmount)}</div>
          </div>
        </TFooter>
      </Cont>
    </ItemContainer>
  )

}

const mapStateToProps = (state) => {
  let valueForm = getFormValues('formGR')(state)
  var totalPages = 0
  var totalPagesSelect = []
  if (valueForm.goodsServiceReceiptPoItems && valueForm.goodsServiceReceiptPoItems.length) {
    totalPages = Math.ceil(valueForm.goodsServiceReceiptPoItems.length / itemPerPage)
    for (let i = 1; i <= totalPages; i++) {
      totalPagesSelect.push(i)
    }
  }
  return {
    valueForm,
    totalPages,
    totalPagesSelect,
  }
}

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(PanelPOInfo)
